import { WIDGET_BRAND } from "./brand";
import vaidebetLogo from "./assets/36.png";

/*
 * Config por marca (1 widget = 1 marca, escolhida em build via REACT_APP_WIDGET_BRAND).
 * Tudo que muda entre marcas mora aqui — o resto do código lê de BRAND, sem marca hardcoded.
 * O tema é aplicado como CSS variables no boot (ver applyBrandTheme + index.tsx); o index.css
 * mantém os valores do vaidebet como fallback.
 */
export interface BrandTheme {
    headerBg: string;
    headerText: string;
    launcherBg: string;
    launcherIcon: string;
    startServiceBg: string;
    startServiceText: string;
    primaryButton: string;
    primaryButtonText: string;
}

interface BrandConfig {
    slug: string;
    headerTitle: string;
    helpCenterUrl: string;
    theme: BrandTheme;
    /* Logo do launcher (build-time, por marca). Sem logo → ícone de chat genérico (nunca o de outra marca). */
    launcherLogo?: string;
}

export const BRANDS: Record<string, BrandConfig> = {
    vaidebet: {
        slug: "vaidebet",
        headerTitle: "Suporte 24 horas",
        helpCenterUrl: "https://atendimentovaidebet.zendesk.com/hc/pt-br",
        launcherLogo: vaidebetLogo,
        theme: {
            headerBg: "#fec537",
            headerText: "#1a1a1a",
            launcherBg: "#fec537",
            launcherIcon: "#1a1a1a",
            startServiceBg: "#000000",
            startServiceText: "#ffffff",
            primaryButton: "#000000",
            primaryButtonText: "#ffffff"
        }
    },
    betpix365: {
        slug: "betpix365",
        headerTitle: "Suporte 24 horas",
        helpCenterUrl: "https://betpix365.zendesk.com/hc/pt-br",
        theme: {
            /* Marca verde #137051 (informado); texto branco sobre o verde. Botões provisórios em verde. */
            headerBg: "#137051",
            headerText: "#ffffff",
            launcherBg: "#137051",
            launcherIcon: "#ffffff",
            startServiceBg: "#137051",
            startServiceText: "#ffffff",
            primaryButton: "#137051",
            primaryButtonText: "#ffffff"
        }
    }
};

export const BRAND: BrandConfig = BRANDS[WIDGET_BRAND] ?? BRANDS.vaidebet;

const CSS_VAR_BY_THEME_KEY: Record<keyof BrandTheme, string> = {
    headerBg: "--header-bg",
    headerText: "--header-text",
    launcherBg: "--launcher-bg",
    launcherIcon: "--launcher-icon",
    startServiceBg: "--start-service-bg",
    startServiceText: "--start-service-text",
    primaryButton: "--primary-button",
    primaryButtonText: "--primary-button-text"
};

export const applyBrandTheme = (theme: BrandTheme, root: HTMLElement = document.documentElement): void => {
    (Object.keys(CSS_VAR_BY_THEME_KEY) as (keyof BrandTheme)[]).forEach((key) => {
        root.style.setProperty(CSS_VAR_BY_THEME_KEY[key], theme[key]);
    });
};
